// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs-module__tabs___KiP01","rightTabs":"Tabs-module__rightTabs___i1yuZ"};